$(document).ready(function () {
  //align height function
  function alignHeight(selector) {
    $(selector).css("height", "");
    var minHeight = 0;
    $(selector).each(function () {
      if (minHeight < jQuery(this).outerHeight()) {
        minHeight = jQuery(this).outerHeight();
      }
    });
    if (minHeight > 0) {
      $(selector).css("height", minHeight);
    }
  }

  //Slide Recomment Product
  var load_recomment_view = setInterval(function () {
    var rowMobile =
      $(".product-recommendations .grid.product-grid").data("total_item") > 2
        ? 2
        : 1;
    if ($(".product-recommendations .grid.product-grid").length) {
      $(".product-recommendations .grid.product-grid")
        .not(".slick-initialized")
        .slick({
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 3,
          arrows: true,
          dots: false,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                rows: rowMobile,
                infinite: true,
                arrows: false,
                dots: true,
              },
            },
          ],
        });
      if ($(window).width() > 767) {
        // DLT-52: exclude article cards (blog feed / previous editions) —
        // they clamp their own titles; a shared inline height breaks them.
        alignHeight(".card:not(.article-card) .card__content .card__heading");
      }
      clearInterval(load_recomment_view);
    }
  }, 500);

  //Select custom pdp
  $(document).on("click", ".select-custom .current-value", function () {
    $(this).toggleClass("active");
  });

  $(document).on(
    "click",
    ".select-custom .product-form__input label",
    function () {
      var value = $(this).text();
      $(this)
        .parents(".select-custom")
        .find(".current-value")
        .removeClass("active");
      $(this)
        .parents(".select-custom")
        .find(".current-value label")
        .text(value);
    },
  );

  //button click custom
  $(".button:not(.button--secondary)").addClass("button--primary");

  $(document).on("click", ".header .header__icon--cart", function () {
    $("#CartDrawer-Checkout").addClass("button--primary");
  });

  $(document).on("touchstart", ".button.button--primary", function () {
    $(this).addClass("primary-clicked");
  });

  $(document).on("touchend", ".button.button--primary", function () {
    $(this).removeClass("primary-clicked");
  });

  $(document).on("touchstart", ".button.button--secondary", function () {
    $(this).addClass("secondary-clicked");
  });

  $(document).on("touchend", ".button.button--secondary", function () {
    $(this).removeClass("secondary-clicked");
  });

  $(document).on("click", ".button.button--primary", function () {
    $(this).addClass("primary-clicked");
  });

  $(document).on("click", ".button.button--secondary", function () {
    $(this).addClass("secondary-clicked");
  });

  $(document).on("focusout", ".button.button--secondary", function () {
    $(this).removeClass("secondary-clicked");
  });

  $(document).on("focusout", ".button.button--primary", function () {
    $(this).removeClass("primary-clicked");
  });

  $(document).mouseup(function (e) {
    var container = $(".cart-drawer .drawer__inner");
    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      $(".template-product .product-form__buttons button").blur();
    }
  });

  $(document).on("click", ".cart-drawer .drawer__close", function () {
    $(".template-product .product-form__buttons button").blur();
  });

  $(window).on("load", function () {
    if (/iP(hone|ad)/.test(window.navigator.userAgent)) {
      document.body.addEventListener("touchstart", function () {}, false);
    }
  });

  //Align height collection
  // DLT-52: exclude article cards (blog feed / previous editions) —
  // they clamp their own titles; a shared inline height breaks them.
  if ($(window).width() > 767) {
    alignHeight(".card:not(.article-card) .card__content .card__heading");
  }

  //Accordion slide
  $(".template-product .product__accordion .accordion__content").each(
    function () {
      if ($(this).height() == 0) {
        $(this).parent().addClass("empty");
        $(this).parents(".pdp").addClass("empty");
      }
    },
  );

  $(
    ".template-product .product__accordion .accordion-title.description",
  ).addClass("open");
  $(
    ".template-product .product__accordion .accordion__content.description",
  ).show();
  $(document).on("click", ".has-accordion .accordion-title", function () {
    if ($(this).hasClass("open")) {
      $(this).parent().find(".content").slideUp();
      $(this).removeClass("open");
    } else {
      $(this).parents(".accordion-list").find(".content").slideUp();
      $(this)
        .parents(".accordion-list")
        .find(".accordion-title")
        .removeClass("open");
      $(this).parent().find(".content").slideDown();
      $(this).addClass("open");
    }
  });

  //Collection banner text
  $(document).on(
    "click",
    ".template-collection .banner-text .close-banner",
    function () {
      $(this).parent().slideUp();
    },
  );

  // remove storage
  const baseURL = window.location.href;

  if (baseURL.includes("checkouts") == false) {
    localStorage.removeItem("checked");
  }
});
// Form validate

var ValidatorForm = {
  validatorFormField: function (formSelector) {
    $(formSelector).validate({
      // use highlight and unhighlight
      rules: {
        term: {
          required: true,
          minlength: 1,
        },
      },
      highlight: function (element, errorClass, validClass) {
        $(element.form)
          .find("label[for=" + element.id + "]")
          .addClass("error-label");
        if (element.type === "radio") {
          this.findByName(element.name)
            .addClass(errorClass)
            .removeClass(validClass);
        } else {
          $(element).addClass(errorClass).removeClass(validClass);
        }
      },
      unhighlight: function (element, errorClass, validClass) {
        $(element.form)
          .find("label[for=" + element.id + "]")
          .removeClass("error-label");
        if (element.type === "radio") {
          this.findByName(element.name)
            .removeClass(errorClass)
            .addClass(validClass);
        } else {
          $(element).removeClass(errorClass).addClass(validClass);
        }
      },
      // NOTE: intentionally no submitHandler here.
      // jQuery Validate's default behaviour lets the native submit event
      // proceed when the form is valid, which allows Shopify's storefront
      // captcha script to intercept the submit and inject the hCaptcha
      // token. A custom submitHandler calling form.submit() bypasses that
      // interception and the server rejects with "Missing CAPTCHA token".
    });
  },
};
// active footer menu mobile
$(
  ".footer__blocks-wrapper .footer-block--menu .footer-block__mobile .footer-block__heading",
).each(function () {
  $(this).on("click", function () {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
        .closest(".footer-block__mobile")
        .find(".footer-block__details-content")
        .slideUp();
    } else {
      $(
        ".footer__blocks-wrapper .footer-block--menu .footer-block__mobile .footer-block__heading",
      ).each(function () {
        $(this).removeClass("active");
        $(this)
          .closest(".footer-block__mobile")
          .find(".footer-block__details-content")
          .slideUp();
      });
      $(this).addClass("active");
      $(this)
        .closest(".footer-block__mobile")
        .find(".footer-block__details-content")
        .slideDown();
    }
  });
});

$("body").on("click", ".cart-page .header__icon--cart", function (e) {
  e.preventDefault();
});

// event touch IOS mobile

const removeErrorClassInput = ($classInput, $classMess) => {
  $($classInput).removeClass("error");
  $($classMess).removeClass("error");
};

const addErrorClassInput = ($classInput, $classMess) => {
  $($classInput).addClass("error");
  $($classMess).addClass("error");
};

$("#newsletter_agree_label").on("click", function () {
  $("#newsletter_agree_checkbox").click();
});

$("#contactSubscribeFooter").on("click", function () {
  const checkEmail = $(".footer__newsletter .newsletter-input").val();

  if (checkEmail.length === 0) {
    addErrorClassInput(
      ".footer__newsletter .newsletter-input",
      ".footer__newsletter .newsletter-email-error",
    );
  } else {
    removeErrorClassInput(
      ".footer__newsletter .newsletter-input",
      ".footer__newsletter .newsletter-email-error",
    );
    $("#ContactFooter").submit();
  }
});

// function validate newsleter in footer

$(".popup-form .newsletter-agree-label").on("click", function () {
  $(".popup-form .newsletter-agree-checkbox").click();
});

$(".popup-form .newsletter-button").on("click", function () {
  const checkEmail = $(".popup-form .newsletter-input").val();

  if (checkEmail.length === 0) {
    addErrorClassInput(
      ".popup-form .newsletter-input",
      ".popup-form .newsletter-email-error",
    );
  } else {
    removeErrorClassInput(
      ".popup-form .newsletter-input",
      ".popup-form .newsletter-email-error",
    );
    $(".popup-form").submit();
  }
});

// Newsletter popup Handle

$(document).ready(function () {
  const newsletterPopup = $("#newsletter-popup");
  const closePopupBtn = $("#close-popup");
  const content = $("#newsletter-popup .popup-content");
  const body = $("body");
  const emailInput = $(".newsletter-popup input[type='email']");
  const termsCheckbox = $(".newsletter-popup .newsletter-agree-checkbox");
  const textMessage = $(".newsletter-popup .newsletter-email-error");
  const agreeMessage = $(".newsletter-popup .newsletter-agree-message");

  if (newsletterPopup.length) {
    // Show the popup
    function showPopup() {
      if (!isFormSubmitted()) {
        newsletterPopup.show();
        newsletterPopup.addClass("open");
        body.addClass("popup-showed");
      }
    }

    // Hide the popup
    function hidePopup() {
      newsletterPopup.hide();
      newsletterPopup.removeClass("open");
      body.removeClass("popup-showed");
    }

    hidePopup();

    content.on("click", function (e) {
      e.stopPropagation();
    });

    body.on("click", function () {
      hidePopup();
    });

    // Close popup when close button is clicked
    closePopupBtn.on("click", function () {
      hidePopup();
    });

    // Check if user is logged in
    function isLoggedIn() {
      const currentUrl = window.location.href;

      if (currentUrl.includes("collections/all")) {
        return true;
      }
      return false;
    }

    function isFormSubmitted() {
      return localStorage.getItem("newsletterSubmitted") === "true";
    }

    // Show the popup only if the user is not logged in
    if (isLoggedIn()) {
      // Show the popup after a certain delay (e.g., 5 seconds)
      setTimeout(function () {
        showPopup();
      }, 3000);
    }

    // Function to validate email
    function validateEmail(email) {
      var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    }

    // Handle form submission
    const newsletterForm = $(".newsletter-popup #contact_form");

    newsletterForm.on("submit", function (event) {
      event.preventDefault();
      var email = emailInput.val().trim();
      var isChecked = termsCheckbox.prop("checked");

      emailInput.removeClass("error");
      // Check if email is valid
      if (!validateEmail(email)) {
        // Display error message or perform other actions
        emailInput.addClass("error");
        textMessage.text("Invalid email");
        textMessage.addClass("error");
        return;
      }

      // Check if terms checkbox is checked
      if (!isChecked) {
        // Display error message or perform other actions
        agreeMessage.addClass("error");
        agreeMessage.text("Please agree to the terms and conditions");
        return;
      }

      this.submit();
      localStorage.setItem("newsletterSubmitted", "true");
    });
  }
});
